/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Options
 * @desc Filter by metadata options
 */

import { FilterPostReportOptionsForm } from 'labstep-web/components/FilterPost/NewIndex/Options/Form';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { FilterPostNewIndexOptionsProps } from './types';

export const FilterPostNewIndexOptions: React.FC<
  FilterPostNewIndexOptionsProps
> = ({
  label,
  path,
  field,
  addPostFilter,
  defaultValues,
  entityName,
  ...rest
}) => (
  <Modal
    header={`Filter by ${label}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text="Filter by this field"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterPostReportOptionsForm
        addPostFilter={addPostFilter}
        path={path}
        field={field}
        defaultValues={defaultValues}
        onDone={toggleModal}
        entityName={entityName}
      />
    )}
    {...rest}
  />
);
